/* eslint-disable unicorn/filename-case */
/* eslint-disable camelcase */

import { ILanguageData } from "../props";

export const enUS: ILanguageData = {
  welcome_login: "Welcome to login",
  account: "Account number",
  password: "password",
  remember_pwd: "Remember password",
  login: "login",
  login_account_required: "username is required",
  login_pwd_required: "password is required",
  input_keyword_search: "Please enter keyword search",
  learning_data: "Learning data",
  my_course: "My courses",
  my_exam: "My exams",
  more_courses: "More courses",
  exam_review: "Exam review",
  departmental_course: "Department Tutorials",
  update_tutorial: "Update tutorial",
  all: "All",
  pending_participation_exam: "To be attended",
  pending_review_exam: "To be reviewed",
  not_passed_exam: "Not passed",
  passed_exam: "Passed",
  course_number: "Course Number",
  course_title: "Course title",
  exam_time: "Exam time",
  exam_duration: "Exam duration",
  quiz_creator: "Quiz Creator",
  total_question_number: "Total number of questions",
  exam_number: "Exam Number",
  remaining_exam_attempts: "Number of remaining exams",
  times: "times",
  check_score: "Check the score",
  start_exam: "Start exam",
  compulsory_course: "Mandatory course",
  elective_course: "Elective course",
  duration: "Duration",
  course: "Courses",
  featured: "Tutorials",
  pcs: "PCS",
  minutes: "minutes",
  data_learned: "Learned", // 不確定
  to_learn: "To learn",
  learned: "Learned",
  learning: "Learning",
  history: "History",
  learning_dueation: "Learning Time",
  lecturer: "Lecturer",
  exam_start_time: "Exam start time",
  exam_end_time: "Exam end time",
  // score: "score： {{score}}points",
  score_one: "score：{{score}}point",
  score_other: "score：{{score}}points",
  view_details: "View details",
  copy_link: "Copy link",
  failed_grade: "failed",
  passed_grade: "passed",
  single_choice: "Single choice",
  multiple_choice: "Multiple choice",
  judgment: "True or false",
  fill_blank: "Fill in the blank",
  // total_score: "Total score：{{totalScore}}points",
  total_score_one: "Total score：{{totalScore}}point",
  total_score_other: "Total score：{{totalScore}}points",
  // questions_total: "{{questionCount}}questions in total",
  questions_total_other: "{{questionCount}} questions in total",
  questions_total_one: "{{questionCount}} question in total",
  exam_submission_time: "Exam Submission Time",
  exam_paper_number: "Exam paper number",
  number_of_associated_course: "Number of associated course",
  exam_marker: "Exam marker",
  number_of_questions_to_be_reviewed: "Number of questions to be reviewed",
  review_status: "Review status",
  operation: "operation",
  to_be_reviewed: "To be reviewed",
  reviewed: "Reviewed", // 未确定
  distributed: "Distributed", // 未确定
  review: "review",
  department: "Department",
  position: "Position",
  nameOfViewer: "Name of viewer",
  organizationOfTheViewer: "Organization of the viewer",
  viewingStatus: "Viewing status",
  viewingTime: "Viewing time",
  question_and_answer: "Question and answer",
  i_posted: "I posted",
  name: "name",
  description: "description",
  personnel_scope: "Scope of personnel",
  shelf_time: "Available from",
  courseware_upload: "Courseware",
  click_or_drag: "Click or drag the file here to upload",
  courseware_stage_has_exam:
    "There is an exam in the stage where the courseware is located",
  extension_support: "Extension support",
  cancel: "Cancel",
  confirm: "Confirm",
  organizational_structure: "Organizational structure",
  selected_person: "Selected person(s)",
  message_center: "Message center",
  message_list: "Message list",
  unread_message: "Unread Message",
  read_message: "Read Message",
  on_the_shelf: "On the shelf",
  removed_from_shelves: "Removed from shelves",
  no_related_content: "Sorry, no related content found",
  unwatched: "Unwatched",
  watching: "Watching",
  watched: "Watched",
  viewing_record: "Viewing record",
  my_viewing_record: "My viewing record",
  delete: "Delete",
  modify: "Modify",
  publisher: "Publisher",
  viewing_time: "Viewing time",
  name_of_viewer: "Name of viewer",
  organization_of_the_viewer: "Organization of the viewer",
  viewing_status: "Viewing status",
  tutorial_staff_watches_the_record: "The tutorial staff watches the record",
  course_introduction: "Course Introduction",
  more: "More",
  course_evaluation: "Course evaluation",
  correctAnswerMessage: "Congratulations, you answered correctly！",
  wrongAnswer: "Sorry, your answer is incorrect!",
  yourAnswer: "Your answer：{{yourAnswer}}",
  correctAnswer: "Correct answer：{{correctAnswer}}",
  answerAnalysis: "Answer Analysis：{{answerAnalysis}}",
  comment: "Comment：{{comment}}",
  mark: "Score: {{score}} points",
  remainingTime: "Remaining Time：",
  submit: "Submit",
  submit_failed: "Submission failed, please try again！",
  submit_success: "Submission succeeded！",
  viewing_history: "Viewing history",
  courseware_name: "Courseware name",
  courseware_number: "Courseware number",
  dept_course: "Departmental course",
  dept_tutorials_number: "Departmental Course Number",
  my_dept_tutorials: "My Department Tutorials",
  course_description: "Course Description",
  tutorial_publish: "Tutorial Publish",
  tutorial_description: "Tutorial Description",
  copy: "Copy",
  copy_success: "Copy successful",
  copy_failed: "Copy failed",
  i_learned: "I learned",
  multiplier: "multiplier",
  clarity: "clarity",
  whether_to_delete_data: "Whether to delete data",
  whether_to_give_up_save: "Whether to give up save",
  yes: "Yes",
  no: "No",
  file_type_not_supported: "Only MP4, MOV, JPG, PNG, PDF formats are supported",
  student_count: "Student Count",
  course_instructor: "Course Instructor",
  learning_progress: "Learning Progress",
  my_pending_courses: "My Pending Courses",
  dept_course_number: "Department Course Number",
  join_course: "Join Course",
  course_expired:
    "Course has exceeded the learning time and cannot be accessed",
  no_tutorials: "No tutorials",
  upload_type_tips:
    "Only the same type of attachments can be uploaded, and only one copy of MP4 and PDF files can be uploaded",
  examination_title: "Examination title", // 不確定
  paper_number: "Paper number", // 不確定
  submitter: "Submitter", // 不确定
  submission_time: "Submission time", // 不確定
  distribution_success: "Distribution success", // 不確定
  distribute: "Distribute", // 不確定
  attachment: "Attachment",
  confirm_exit_exam: "Do you want to exit the exam?",
  clear_unread: "Clear Unread Message",
  scan_qr_code:
    "Please scan the QR code above to fill out the course evaluation",
  distribution_select_results: "Please select a result to distribute", // 不确定
  pending_examination: "Pending examination", // 不确定
  test_paper_submission_time: "Test paper submission time", // 不確定
  answer: "Answer", // 不確定
  review_score: "score", // 不確定
  points: "points", // 不確定
  review_remark: "comment", // 不確定
  review_remark_empty: "Comments cannot be empty", // 不确定
  review_points_empty: "Points cannot be empty", // 不确定
  tutorials: "Tutorials",
  tutorials_number: "Tutorials Number",
  logout: "Log out",
  version: "Version",
  empty_exams: "No examination",
  empty_course: "No course",
  empty_score: "No results",
  empty_content: "No content",
  clear: "Clear",
  echo_avatar: "Echo Avatar",
  translation_video: "Translate video",
  start_make: "Start Making",
  sure_make: "Confirm Make",
  cancel_making: "Close",
  cancel_make: "Cancel",
  language: "Language",
  tone: "Timbre",
  make_state: "Production status",
  speech_draft: "Speech Draft",
  download: "Download",
  download_failed_open_tab:
    "Download failed, please download manually in new tab",
  try_listen: "Trial listen",
  template_download: "Template Download",
  output_language_speech_color_selection:
    "Output language speech color selection",
  original_language: "Source language",
  translation_language: "Translation language",
  video_duration: "Video duration",
  video_name: "Video name",
  ea_note:
    "Note: If you need to clone the voice timbre, please create it on the Echo Avatar client (please log in with the same account).",
  ea_tooltip:
    "Speech can choose whether to import; If it is not imported, the system will recognize the audio in the video by artificial intelligence and generate the speech intelligently; If imported, the system will produce multi-language versions according to the content of the speech.",
  total_video_duration: "Total video duration",
  original: "Original text",
  translation: "Translated text",
  word_count: "Word count",
  back: "Return",
  sure: "OK",
  preview: "Preview",
  batch_download: "Batch Download",
  multilingual_translation: "Multilingual translation",
  ea_hash: "Hash",
  making: "Making",
  please_select_the_original_language: "Please select the source language",
  please_select_the_target_language: "Please select the target language",
  please_select_language: "Please select language",
  please_select_a_tone: "Please select the voice timbre",
  whether_to_cancel_production: "Whether to cancel production",
  search_history: "Search history",
  target_language: "Target language",
  create_translation_video: "Create translated video project",
  advanced_option: "Advanced options",
  subtitles: "Subtitles",
  video_advanced_option: {
    option1:
      "Retain background sounds（retain music, noise, etc., non-human voices）",
    option2:
      "Direct translation（Skip the text verification step and directly output the result video）",
    option3: "Subtitles（Generate subtitles in the target language）",
  },
  original_language_and_target_language_conflict:
    "原始语言不能与目标语言相同，请重新选择",
  save: "Save",
  translate: "Translate",
  ai_analysis: "AI analysis",
  regular_duration: "Normal time",
  recommended_duration: "Recommended time",
  ai_rewrite: "AI rewrite",
  slow_speech_rate_tip: {
    option1: "Slow speech",
    option2:
      "The translated text is shorter than the original text. We recommend adding the number of characters in the natural speech rhythm.",
  },
  fast_speech_rate_tip: {
    option1: "Fast speech",
    option2:
      "The translated text is longer than the original text. We recommend reducing the number of characters in the natural speech rhythm.",
  },
  subtitle_time_range_is_incorrect: {
    option1: "The start time cannot exceed the end time",
    option2: "The end time cannot exceed the start time of the next sentence",
  },
  video_time_format: "The time format is HH:mm:ss,mmm",
  making_tips: "Generating {{progress}}%",
  no_data: "No data available",
  index_page: "Home",
  share: "Share",
  playing_failed: "Fail to play",
  intelligent_creation: {
    intelligent_creation: "Intelligent Creation",
    dual_podcast: "Dual Podcast",
    single_person_talk: "Single Person Talk",
    background_image: "Background Image",
    creation_type: "Creation Type",
    audio: "Audio",
    video: "Video",
    upload_text: "Click to upload",
    upload_tip:
      "Only .pdf files are supported, and the file size cannot exceed 10mb",
    podcard_content_tip: "Please input podcast content or upload PDF file",
    ai_creation: "AI Creation",
    use_my_script: "Use My Script",
    podcast_content_input_placeholder_ai:
      "Enter topics, ideas, or upload reference materials to let AI generate a complete podcast script with one click.",
    podcast_content_input_placeholder_custom:
      "Enter an existing script, and the system will automatically convert it into a corresponding podcast script.",
    script_format_requirement:
      'Format tips:\n·Line breaks are required to distinguish between "Host" and "Guest" dialogues.\n·Dialogue roles are limited to "Host" and "Guest".',
    script_format_example:
      "[Format Example]\nHost: Hello everyone...\nGuest: Yes, we...\nHost: So...\nGuest: Indeed, actually...",
    script_format_error:
      "The script does not meet the format requirements. Please edit it and try again.",
    input_script_placeholder: "Please enter script",
    apply_script: "Apply Script",
    mandarin: "Mandarin",
    cantonese: "Cantonese",
    compere: "Compere",
    interview_guest: "Guest",
    my_tone: "My tone",
    digital_image_and_timbre: "Digital image and timbre",
    my_customization: "My customization",
    system_tone: "System tone",
    podcast_content: "Podcast content",
    system_presets: "System presets",
    custom: "Custom",
    customize: "Customize",
    tone_genere_tip: "Generating tone, please wait about {{minutes}} minutes",
    generate_script: "Generate script",
    no_content: "Please complete the settings first～",
    generate_audio: "Generate audio",
    generate_video: "Generate video",
    audio_balance: "Audio balance(hour:minute:second)",
    video_balance: "Video balance(hour:minute:second)",
    audio_generate_tip:
      "Note: Due to the nature of AI generation, the final audio/video duration may vary slightly. Credit deductions will be applied based on the actual duration.",
    too_long_script_tip:
      "The overall length of the script is too long and does not meet the duration setting. Please re-edit it or ask the AI to assist in the modification through instructions.",
    too_short_script_tip:
      "The overall length of the script is too short and does not meet the duration setting. Please re-edit it or ask the AI to assist in the modification through instructions.",
    tone_customization: "Tone customization",
    upload_file_tip1: "The file is too large, please upload again",
    upload_file_tip2:
      "The duration does not meet the requirements. Please re-upload",
    whether_to_confirm_deletion: "Whether to confirm deletion?",
    whether_to_confirm_submission: "Whether to confirm submission?",
    material_text: "Material Text",
    material_text_tip:
      "Text is generated by AI recognition. If it differs from the original material, you can edit it to improve voice cloning accuracy.",
    material_language: "Material Language",
    tone_name: "Tone name",
    reference_audio: "Reference audio",
    upload_audio_tip:
      'Please upload clear personal voice audio (language must match "Continued Language", requires no background noise and only 1 person\'s voice)',
    upload_audio_tip2: "Format: MP3, Size: within 150MB",
    generating: "generating",
    script_generating: "generating script",
    script_generat_failed: "script generation failed, please try again",
    basic_setting_changed_tip:
      "Settings have changed, please regenerate the script!",
    delete_tone_tip1:
      "The selected timbre cannot be deleted, please adjust and try again",
    delete_tone_tip2: "Audio is being generated, cannot be deleted",
    generate_failed_tip: "Generation failed, please try again later",
    queuing_tip: "In the queue, expected to wait for a few minutes",
    queuing_tip1:
      "In the queue, generation is expected to begin in {{minutes}} minutes.",
    submit_tip: "（After submission, it cannot be modified again）",
    draft_tip: "tip",
    draft_tip1:
      "There is a task of generation in queue/generated/completed. Do you want to continue?",
    draft_tip2: "（Once abandoned, it will not be saved）",
    back_tip1: "Have you confirmed your return?",
    back_tip2:
      "(If there are any tasks in the queue, generated or completed, you can check them again when you enter next time. If there are none, they will not be saved.)",
    background_sound_error_tip: "Background noise detected, please re-upload",
    invalid_voice_error_tip: "No valid human voice detected, please re-upload",
    multiple_voices_error_tip: "Multiple voices detected, please re-upload",
    audio_check_failed_error_tip: "Audio check failed, please re-upload",
    no_pdf_file_error_tip: "Only PDF files are supported, please re-upload",
    checking: "Checking",
    host: "host",
    guest: "guest",
    digital_image: "digital image",
    digital_image_group: "digital image group",
    add_digital_image_group: "add digital image group",
    my_digital_images: "my digital images",
    no_digital_image_tip:
      "No options available. Please complete customization first!",
    ai_generate: "AI generate",
    over_word_limit_tip:
      "The character limit has been reached. Any excess characters cannot be entered.",
    upload_photo: "Upload photo",
    upload_photo_tip1:
      "Please upload a personal photo (single person, facing forward, ensuring no obstructions to the face) for generating a digital avatar",
    upload_photo_tip2: "Format: png/jpg  Size: Under 10MB",
    under_inspection: "Under inspection",
    digital_image_customization: "Digital image customization",
    least_one_dialogue_box_tip: "There must be at least one dialog box",
    detect_faild_tip: "The service is currently busy. Please try again later.",
    no_full_face_image_tip: "Please upload a full face photo",
    no_single_person_image_tip:
      "Only single person photos are supported, please re-upload",
    contains_illegal_content_tip: "Contains illegal content, please re-upload",
    clarity_low_tip: "Clarity is low, please re-upload again",
    no_original_image_tip: "Please upload the original image directly",
    simple_chinese: "Simple Chinese",
    traditional_chinese: "Traditional Chinese",
    over_limit_tip:
      "{{name}} have exceeded the current capacity limit. To add new items, please delete the excess content first.",
    personal_tone: "personal tone",
    personal_digital_image: "personal digital image",
    personal_digital_image_tip: "Please add a new digital image group first",
    personal_tone_tip: "Tone cannot be empty",
    no_generation_result: "No generation results yet",
    digital_human_footage: "Digital human footage",
    add_digital_human_footage: "Add digital human footage",
    digital_human_footage_tip: "Please add a digital human footage first",
    creation_content: "Creation content",
  },
  input_placeholder: "please input",
  no_permissions: "No permissions",
  add: "Add",
  delete_success: "Deleted successfully",
  route_error: "Invalid route!",
};
